// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__-vE8r","align-center":"styles_align-center__3itpO","align-bottom":"styles_align-bottom__2_B19"};